import React from "react";
import FaqAccordion from "../faqAccordion/faqAccordion";

const Blog2 = ({ blog }) => {
  // Table styles defined as objects for cleaner JSX
  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    margin: "20px 0",
    fontSize: "14px",
    color: "#333",
  };

  const cellStyle = {
    border: "1px solid #ddd",
    padding: "12px",
    textAlign: "left",
  };

  const headerStyle = {
    ...cellStyle,
    backgroundColor: "#f3e8ff",
    color: "#480866",
    fontWeight: 700,
  };

  const rowEvenStyle = {
    backgroundColor: "#f9f9f9",
  };

  return (
    <div className="parent-container">
      <div className="main-container-blogpage" id="blog-content-container">
        <div className="category-tag">{blog.category}</div>
        <p className="headline-page">{blog.mainTitlePage}</p>
        <p className="date">{blog.publishDate}</p>
        <div className="image-container">
          <img className="img" src={blog.detailImage} alt={blog.imageAlt} />
        </div>

        <p className="paragraph-content">
          Par kya agar har mahine thoda sa save ho jaye?
          <br />
          Simple Steps. Steady Progress.
        </p>

        <p className="sub-paragraph-heading">Coins Turning Into Confidence</p>
        <p className="sub-paragraph-content">
          You don't need a bada lump sum.
          <br />
          ₹10, ₹50, ₹100 - start wahi se.
          <br />
          When you see coins turning into grams of gold or a tiny SIP growing
          month by month, confidence bhi aata hai.
        </p>

        <p className="sub-paragraph-heading">
          How Micro-Savings Actually Make You Richer
        </p>
        <div className="sub-paragraph-content">
          Let's talk numbers for a minute - not vibes.
          <br />
          <br />
          Even ₹100 a day = ₹3,000 a month.
          <br />
          Invest that at an average 8% annual return (mutual fund or
          digital-gold SIP):
          <br />
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={headerStyle}>Time</th>
                <th style={headerStyle}>Total Put In</th>
                <th style={headerStyle}>Approx. Value</th>
                <th style={headerStyle}>What That Means</th>
              </tr>
            </thead>
            <tbody>
              <tr style={rowEvenStyle}>
                <td style={cellStyle}>1 year</td>
                <td style={cellStyle}>₹36,000</td>
                <td style={cellStyle}>₹37,250</td>
                <td style={cellStyle}>A paid-off phone bill, stress-free.</td>
              </tr>
              <tr>
                <td style={cellStyle}>5 years</td>
                <td style={cellStyle}>₹1.8 lakh</td>
                <td style={cellStyle}>₹2.2 lakh</td>
                <td style={cellStyle}>A full emergency fund.</td>
              </tr>
              <tr style={rowEvenStyle}>
                <td style={cellStyle}>10 years</td>
                <td style={cellStyle}>₹3.6 lakh</td>
                <td style={cellStyle}>₹5.4 lakh</td>
                <td style={cellStyle}>A down payment, or 18 months of rent.</td>
              </tr>
              <tr>
                <td style={cellStyle}>20 years</td>
                <td style={cellStyle}>₹7.2 lakh</td>
                <td style={cellStyle}>₹14.7 lakh</td>
                <td style={cellStyle}>Real wealth — not theory, not luck.</td>
              </tr>
            </tbody>
          </table>
          <br />
          <p style={{ color: "#333333", fontSize: "20px", fontWeight: 400 }}>
            That's how "₹10, ₹50, ₹100" quietly become assets.
            <br />
            You're not just saving coins—you're buying future options: fewer
            panic moments and more freedom to choose.
            <br />
            That's richer.
          </p>
        </div>

        <p className="sub-paragraph-heading">Future You Will Thank You</p>
        <p className="sub-paragraph-content">
          Imagine this: ek saal baad, jab emergency aaye, panic nahi hota.
          <br />
          A little gold, a small SIP, aur ek safe stash that grew quietly in the
          background.
          <br />
          You didn't earn more — you just handled better.
        </p>

        <p className="sub-paragraph-heading">
          When Saving Feels Like a Game — Not a Burden
        </p>
        <div className="sub-paragraph-content">
          kPaisa makes this possible:
          <br />
          <ul style={{ listStyle: "none", paddingLeft: 0 }}>
            <li style={{ marginBottom: "10px", color: "black" }}>
              • Start from ₹1 — yes, ₹1 investments and gold.
            </li>
            <li style={{ marginBottom: "10px", color: "black" }}>
              • Auto-save: paise side ho jaate hain before you spend.
            </li>
            <li style={{ marginBottom: "10px", color: "black" }}>
              • Micro-investments with instant liquidity — no scary paperwork.
            </li>
            <li style={{ marginBottom: "10px", color: "black" }}>
              • Rewards make it fun — saving feels like a game, not a lecture.
            </li>
          </ul>
          <br />
          <p style={{ color: "#333333", fontSize: "20px", fontWeight: 400 }}>
            Design simple hai. Language clear hai. No hidden fees.
            <br />
            Bas results.
          </p>
        </div>

        <p className="sub-paragraph-heading">One Small Tip</p>
        <div className="sub-paragraph-content">
          Start with one small habit today.
          <br />
          Set ₹50 or ₹100 auto-save for this month.
          <br />
          See the little gram count rise. Feel the shift.
          <br />
          <br />
          <a
            href="https://kleio.app.link/download"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1155cc", textDecoration: "underline" }}
          >
            Start small with<b> kPaisa</b> — see how ₹10 grows into more than
            money.
          </a>
        </div>

        <div className="faq-heading-container">
          <p className="sub-paragraph-heading-faq">
            Frequently asked questions
          </p>
        </div>
        <FaqAccordion>
          <h4 className="faq-question">
            My income changes month to month - can I still use kPaisa?
          </h4>
          <p className="faq-answer">
            Bilkul. Flexible auto-saves (daily, weekly, or monthly) adjust
            automatically to your income - bina stress.
          </p>
        </FaqAccordion>
        <FaqAccordion>
          <h4 className="faq-question">
            What if I forget to save or skip a month?
          </h4>
          <p className="faq-answer">
            kPaisa auto-saves for you. Even if you pause, your progress stays
            safe. Pick up anytime - no guilt, no penalty.
          </p>
        </FaqAccordion>
        <FaqAccordion>
          <h4 className="faq-question">
            Can small savings really make any difference?
          </h4>
          <p className="faq-answer">
            100%. ₹10/day = ₹3,650 a year. ₹3,000/month for 5 years at 8% = ₹2.2
            lakh. It's not luck - it's math and habit compounding together.
          </p>
        </FaqAccordion>
        <br></br>
        <br></br>
      </div>
    </div>
  );
};

export default Blog2;
